
              var p = window['__malt_cdn_url'];
              if (p) {
                   __webpack_public_path__ = p + (__webpack_public_path__ || '');
              }
            